import LegalForm from './LegalForm';

export default LegalForm;
